import { useState } from 'react';
import api from '../utils/api';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';
import { toast } from 'sonner';


export function ChangePasswordDialog({ open, onOpenChange }) {
  const [form, setForm] = useState({ current_password: '', new_password: '', confirm_password: '' });
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.new_password !== form.confirm_password) {
      toast.error('New password and confirm password do not match');
      return;
    }
    if (form.new_password.length < 4) {
      toast.error('New password must be at least 4 characters');
      return;
    }
    setSubmitting(true);
    try {
      await api.post(`/api/auth/change-password`, {
        current_password: form.current_password,
        new_password: form.new_password,
      });
      toast.success('Password changed successfully');
      setForm({ current_password: '', new_password: '', confirm_password: '' });
      onOpenChange(false);
    } catch (error) {
      const detail = error.response?.data?.detail;
      toast.error(typeof detail === 'string' ? detail : 'Failed to change password');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Change Password</DialogTitle>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4 pt-4">
          <div className="space-y-2">
            <Label className="text-sm font-bold uppercase tracking-[0.2em] text-zinc-500">Current Password *</Label>
            <Input
              data-testid="change-pw-current"
              type="password"
              required
              value={form.current_password}
              onChange={(e) => setForm(prev => ({ ...prev, current_password: e.target.value }))}
              className="h-11"
            />
          </div>
          <div className="space-y-2">
            <Label className="text-sm font-bold uppercase tracking-[0.2em] text-zinc-500">New Password *</Label>
            <Input
              data-testid="change-pw-new"
              type="password"
              required
              value={form.new_password}
              onChange={(e) => setForm(prev => ({ ...prev, new_password: e.target.value }))}
              className="h-11"
            />
          </div>
          <div className="space-y-2">
            <Label className="text-sm font-bold uppercase tracking-[0.2em] text-zinc-500">Confirm New Password *</Label>
            <Input
              data-testid="change-pw-confirm"
              type="password"
              required
              value={form.confirm_password}
              onChange={(e) => setForm(prev => ({ ...prev, confirm_password: e.target.value }))}
              className="h-11"
            />
          </div>
          <div className="flex gap-3 justify-end pt-4">
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
            <Button
              type="submit"
              data-testid="change-pw-submit"
              disabled={submitting}
              className="bg-blue-600 hover:bg-blue-700 text-white"
            >
              {submitting ? 'Changing...' : 'Change Password'}
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
